import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { HR_EMPLOYEE_NOTIFICATIONS } from '../employeeNotificationEndpoints'
import { EMPLOYEE_NOTIFICATIONS_QUERY_KEY } from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { PaginatedEmployeeNotificationsDto } from '@/modules/Notification/types/api/employeeNotification'

export interface FetchEmployeeNotificationsPaginatedParams {
  pageIndex: number
  pageSize: number
  isRead?: boolean | null
}

export function fetchEmployeeNotificationsPaginated(
  params: FetchEmployeeNotificationsPaginatedParams
): Promise<PaginatedEmployeeNotificationsDto> {
  return axiosInstance
    .get<PaginatedEmployeeNotificationsDto>(HR_EMPLOYEE_NOTIFICATIONS, {
      params: {
        PageIndex: params.pageIndex,
        PageSize: params.pageSize,
        ...(params.isRead != null ? { IsRead: params.isRead } : {}),
      },
    })
    .then((response) => response.data)
}

export function useEmployeeNotificationsPaginatedQuery(
  params: MaybeRefOrGetter<FetchEmployeeNotificationsPaginatedParams>,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchEmployeeNotificationsPaginated>>
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: computed(() => [
      EMPLOYEE_NOTIFICATIONS_QUERY_KEY,
      toValue(params),
    ]),
    queryFn: () => fetchEmployeeNotificationsPaginated(toValue(params)),
    ...options,
  })
}
